import { Spinner } from "@dash/spinner";
import { useTheme } from "@emotion/react";
import React from "react";
import { Document, Page, pdfjs } from "react-pdf";

export const PdfViewer: React.FC<{
  file: Uint8Array | Blob | null;
  showPreviewFunction: () => void;
  error: string | null;
  loading: boolean;
}> = React.memo(({ file, showPreviewFunction, error, loading }) => {
  const theme = useTheme();

  if (loading) {
    return (
      <div
        css={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "180px",
          width: "100%",
        }}
      >
        <Spinner color={theme.colors.primary} size="28px" />
      </div>
    );
  }

  if (error) {
    return (
      <div
        css={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "60px",
          width: "auto",
          color: theme.colors.primary,
          fontSize: "14px",
          textAlign: "center",
        }}
      >
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div
      css={{
        position: "relative",
        width: "100%",
        height: "180px",
        overflow: "hidden",
        cursor: "pointer",
      }}
      onClick={showPreviewFunction}
    >
      <div
        css={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "top",
          overflow: "hidden",
        }}
      >
        <Document
          file={{ data: file }}
          // eslint-disable-next-line no-console
          onLoadError={(error) => console.error("PDF Load Error:", error)}
          loading={
            <div
              css={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "180px",
                width: "100%",
              }}
            >
              <Spinner color={theme.colors.primary} size="28px" />
            </div>
          }
        >
          <Page
            pageNumber={1}
            scale={0.5}
            css={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "cover",
              objectPosition: "top",
            }}
          />
        </Document>
      </div>
    </div>
  );
});
